module.exports = __webpack_public_path__ + "img/face_shape_female_extra_rect_mask.03f3fac0.png";